// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cms-breadcrumbs__item[data-v-0ddb71db]:not(:last-child):after{content:var(--cms-breadcrumb-separator)}@media speech{.cms-breadcrumbs__item[data-v-0ddb71db]:not(:last-child):after{display:none;visibility:hidden}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
